import { observer } from 'mobx-react';
import { Ready } from '../../Types';
import BigNumber from './BigNumber';
import { when } from '@execonline-inc/maybe-adapter';

interface Props {
  state: Ready;
}

const licensesActivatedPercent = (ratio: number): string =>
  when(ratio < 0.01 && ratio > 0, '<1%')
    .orElse(() => when(ratio > 0.99 && ratio < 1, '>99%'))
    .getOrElse(() => Math.round(ratio * 100).toLocaleString() + '%');

function BigNumbers({ state }: Props) {
  return (
    <div className="flex justify-between gap-3">
      <BigNumber text="Licenses Purchased">
        {state.resource.payload.licensesPurchased.toLocaleString()}
      </BigNumber>
      <BigNumber text="Licenses Activated">
        {licensesActivatedPercent(state.resource.payload.licensesActivatedRatio)}
      </BigNumber>
      <BigNumber text="Licenses Available">
        {state.resource.payload.licensesAvailable.toLocaleString()}
      </BigNumber>
    </div>
  );
}

export default observer(BigNumbers);
